import React from 'react';

function FieldBar({ label, count, total, rate }) {
  const percentage = rate || 0;
  let barColor = 'bg-green-500';
  if (percentage < 50) barColor = 'bg-red-500';
  else if (percentage < 80) barColor = 'bg-amber-500';

  return (
    <div className="mb-3">
      <div className="flex justify-between items-baseline mb-1">
        <span className="text-sm font-medium text-slate-700">{label}</span>
        <span className="text-xs text-slate-500">
          {count.toLocaleString()} of {total.toLocaleString()} ({percentage}%)
        </span>
      </div>
      <div className="w-full bg-slate-100 rounded-full h-2.5">
        <div
          className={`${barColor} h-2.5 rounded-full transition-all`}
          style={{ width: `${Math.max(percentage, 1)}%` }}
        />
      </div>
    </div>
  );
}

export default function CompletenessBar({ requiredFields, optionalFields, totalAssets }) {
  const { population_rates, missing_counts } = requiredFields;

  const mandatoryFields = [
    { key: 'id', label: 'Unique ID' },
    { key: 'file', label: 'Filename' },
    { key: 'title', label: 'Title' },
    { key: 'folder', label: 'Folder path' },
  ];

  const optionalFieldsList = [
    { key: 'tags', label: 'Tags / Keywords' },
    { key: 'description', label: 'Description' },
    { key: 'copyright_status', label: 'Copyright status' },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h3 className="text-sm font-semibold text-slate-700 mb-4">Metadata Completeness</h3>

      <div className="mb-4">
        <div className="text-xs font-semibold uppercase text-slate-400 tracking-wide mb-2">
          Mandatory for Frontify
        </div>
        {mandatoryFields.map(({ key, label }) => {
          const populated = totalAssets - (missing_counts[key] || 0);
          return (
            <FieldBar
              key={key}
              label={label}
              count={populated}
              total={totalAssets}
              rate={population_rates[key] || 0}
            />
          );
        })}
      </div>

      <div>
        <div className="text-xs font-semibold uppercase text-slate-400 tracking-wide mb-2">
          Optional but recommended
        </div>
        {optionalFieldsList.map(({ key, label }) => {
          const field = optionalFields[key];
          if (!field) {
            return (
              <FieldBar
                key={key}
                label={label}
                count={0}
                total={totalAssets}
                rate={0}
              />
            );
          }
          return (
            <FieldBar
              key={key}
              label={label}
              count={field.populated_count}
              total={totalAssets}
              rate={field.population_rate}
            />
          );
        })}
      </div>
    </div>
  );
}
